/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Save_ChangesInputs */

const en_save_changes = /** @type {(inputs: Save_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save Changes`)
};

const es_save_changes = /** @type {(inputs: Save_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar cambios`)
};

const fr_save_changes = /** @type {(inputs: Save_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer les modifications`)
};

const de_save_changes = /** @type {(inputs: Save_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderungen speichern`)
};

const ja_save_changes = /** @type {(inputs: Save_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変更を保存`)
};

const zh_save_changes = /** @type {(inputs: Save_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存更改`)
};

const ar_save_changes = /** @type {(inputs: Save_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حفظ التغييرات`)
};

const id_save_changes = /** @type {(inputs: Save_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simpan Perubahan`)
};

const it_save_changes = /** @type {(inputs: Save_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva Modifiche`)
};

const ru_save_changes = /** @type {(inputs: Save_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохранить изменения`)
};

const pt_save_changes = /** @type {(inputs: Save_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar Alterações`)
};

const ko_save_changes = /** @type {(inputs: Save_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`변경 사항 저장`)
};

/**
* | output |
* | --- |
* | "Save Changes" |
*
* @param {Save_ChangesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const save_changes = /** @type {((inputs?: Save_ChangesInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Save_ChangesInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_save_changes(inputs)
	if (locale === "es") return es_save_changes(inputs)
	if (locale === "fr") return fr_save_changes(inputs)
	if (locale === "de") return de_save_changes(inputs)
	if (locale === "ja") return ja_save_changes(inputs)
	if (locale === "zh") return zh_save_changes(inputs)
	if (locale === "ar") return ar_save_changes(inputs)
	if (locale === "id") return id_save_changes(inputs)
	if (locale === "it") return it_save_changes(inputs)
	if (locale === "ru") return ru_save_changes(inputs)
	if (locale === "pt") return pt_save_changes(inputs)
	return ko_save_changes(inputs)
});